function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9929 21H14.4442L15.5701 16.0728H19.2185L19.6746 13.9647H16.0546L17.0238 9.83576H20.5439L21 7.74012H17.5226L18.62 3H16.1829L15.057 7.74012H10.6817L11.7648 3H9.34204L8.21615 7.74012H4.78147L4.29691 9.83576H7.73159L6.79097 13.9647H3.47031L3 16.0728H6.29216L5.16627 21H7.58907L8.72922 16.0728H13.133L11.9929 21ZM9.11401 14.0644L10.1116 9.74844H14.6865L13.6746 14.0644H9.11401Z",
  fill: "black"
}));

var SvgIcoDies161 = function SvgIcoDies161(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoDies161, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-dies-16-1.697da482.svg";
export { ForwardRef as ReactComponent };